import React from "react";
import { useNavigate } from "react-router-dom";
import Modal from "../ui/Modal";
import Button from "../ui/Button";

const MentalHealthPopup = ({ open, onClose, onExplore, transformOrigin }) => {
  const navigate = useNavigate();

  return (
    <Modal
      open={open}
      onClose={onClose}
      transformOrigin={transformOrigin}
      header={
        <h2 className="text-2xl font-bold text-black text-center mb-6 font-playfair">
          Caregiving & Mental Health
        </h2>
      }
      footer={
        <div className="flex justify-center pt-6">
          <Button
            title="Explore"
            onClick={() => {
              if (onExplore) {
                onExplore();
              } else {
                onClose();
                navigate("/tabs?tab=mental-health");
              }
            }}
          />
        </div>
      }
    >
      <div className="space-y-3">
        <p className="text-base font-normal leading-loose text-black mb-4">
          Caregiving is a journey filled with moments that can be both
          fulfilling and challenging. Being a caregiver can be highly stressful,
          and have significant negative effects on mental health. The
          uncertainties while taking care of someone, financial challenges, the
          stress of making decisions, and changes in family dynamics often leave
          caregivers emotionally drained.
        </p>

        <p className="text-base font-normal leading-loose text-black mb-4">
          In order to provide effective support to caregivers, it is imperative
          that support systems developed for them also focus on mental health
          care. While the need is apparent, there are many societal barriers
          that prevent people from accessing or receiving the mental health
          support they need.
        </p>

        <p className="text-base font-normal leading-loose text-black mb-3">
          The topics in this section include:
        </p>

        <ul className="space-y-1 text-base font-normal leading-loose text-black list-disc pl-6 mb-6">
          <li>The need for emotional support to caregivers</li>
          <li>Developing a better understanding of mental health</li>
          <li>Mental health for all: The way forward</li>
          <li>Community-based mental healthcare with examples</li>
          <li>
            How countries of the Nooraverse fare in mental healthcare and
            support (India, Bangladesh, Indonesia, Nepal)
          </li>
        </ul>
      </div>
    </Modal>
  );
};

export default MentalHealthPopup;
